export const ASC = 'ASC';
export const DSC = 'DESC';

export type types = typeof ASC | typeof DSC | any;
